import { generateAllScales } from '../utils/scaleGenerator.js';

export const MUSICAL_KEYS = generateAllScales();